import React from 'react';
import { AvatarStack } from './Avatar';
import { ONLINE, VERSIONS } from './data';
import { Version } from './types';
interface HeaderBarProps {
  version: Version;
  comparing: boolean;
  activeVersionId: string;
  onToggleCompare: () => void;
}
export function HeaderBar({
  version,
  comparing,
  onToggleCompare
}: HeaderBarProps) {
  const hasBlockers = version.blockers.length > 0;
  return <div style={{
    padding: '8px 20px',
    borderBottom: '1px solid #E6E4DF',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: 12
  }} data-id="element-123">
      <button style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: 16,
      color: '#8896A6'
    }} data-id="element-124">
        ←
      </button>
      <div style={{
      flex: 1
    }} data-id="element-125">
        <div style={{
        fontSize: 10,
        color: '#8896A6'
      }} data-id="element-126">
          Pipeline / Q1 Brand /{' '}
          <span style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 9
        }} data-id="element-127">
            AD-20241-S
          </span>
        </div>
        <div style={{
        fontFamily: "'Lora', Georgia, serif",
        fontSize: 16
      }} data-id="element-128">
          Flagship Equity — Digital Display
        </div>
      </div>
      <AvatarStack uids={ONLINE} data-id="element-129" />
      <span style={{
      fontSize: 10,
      color: '#94A3B8'
    }} data-id="element-130">
        2 online
      </span>
      <div style={{
      width: 1,
      height: 20,
      background: '#E6E4DF'
    }} data-id="element-131" />
      <button onClick={onToggleCompare} style={{
      padding: '4px 10px',
      borderRadius: 5,
      border: comparing ? '1.5px solid #2563EB' : '1.5px solid #E6E4DF',
      background: comparing ? '#EFF6FF' : 'white',
      color: comparing ? '#2563EB' : '#5A6B7C',
      fontSize: 11,
      fontWeight: 600,
      cursor: 'pointer',
      fontFamily: 'inherit'
    }} data-id="element-132">
        {comparing ? '✕ Compare' : '◐ Compare'}
      </button>
    </div>;
}